import { createFileRoute } from "@tanstack/react-router";
import { requireActive } from "../lib/require-active";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/settings")({
  head: () => pageHead("page.settings"),
  beforeLoad: ({ context }) => {
    requireActive(context);
  },
});
